module.exports = __webpack_public_path__ + "static/media/telegram.39a2aaea.svg";